import {gql} from '@apollo/client';
import {CustomerComplaint, ComplaintAppealDetail} from '../types/CustomerComplaintType';

const RELATED_PACKAGE_FIELDS = `
    trackingNumber
    deliveredDriverName
    podImageS3KeysJson
    podImageS3UrlsJson
`;

const COMPLAINT_BASE_FIELDS = `
    complaintType
    complaintReason {
        text
        lang
        translations {
            lang
            text
        }
    }
    source
    externalRefId
    trackingNumber
    orderOverallStatus
    status
    isFinished
    appealDeadlineAt
    finishedAt
    createdAt
    operatorName
`;

const APPEAL_DETAIL_FIELDS = `
    appealReason {
        text
        lang
        translations {
            lang
            text
        }
    }
    appealAttachmentS3UrlsJson
    appealSubmittedAt
    reviewResult
    reviewComment {
        tagKeys
        tagOptions {
            code
            displayOrder
            texts {
                lang
                text
            }
        }
        text
        lang
        translations {
            lang
            text
        }
    }
    reviewedAt
`;

export const GET_DSP_COMPLAINT_DETAIL = gql`
    query GetDspComplaintDetail($complaintId: Long!) {
        getDspComplaintDetail(complaintId: $complaintId) {
            complaint {
                ${COMPLAINT_BASE_FIELDS}
            }
            relatedPackage {
                ${RELATED_PACKAGE_FIELDS}
            }
            appealDetail {
                ${APPEAL_DETAIL_FIELDS}
            }
        }
    }
`;

export interface ComplaintRelatedPackage {
    trackingNumber?: string;
    deliveredDriverName?: string;
    podImageS3KeysJson?: string[];
    podImageS3UrlsJson: string[];
}

export interface DspComplaintDetail {
    complaint: CustomerComplaint;
    relatedPackage?: ComplaintRelatedPackage;
    appealDetail?: ComplaintAppealDetail;
}

export interface GetDspComplaintDetailResponse {
    getDspComplaintDetail?: DspComplaintDetail;
}

export interface GetDspComplaintDetailVariables {
    complaintId: number;
}
